import { Api } from '@firmable/contracts';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import axios from 'axios';

type ApiResponse = {
  success: boolean;
  filters: Api.App.Filter[];
  search: Api.App.Search[];
};

// Homepage is the interim name, we can settle on a better name once we have a better understanding of the data
export function useHomePage() {
  return useQuery({
    queryKey: [Query.AppKeys['home-page']],
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    retry: false,
    queryFn: async () => {
      const resp = await axios.get<ApiResponse>(`${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/homepage`);
      return resp.data;
    },
  });
}
